import './InfoCard.module.less'
import { Card } from 'antd'

const InfoCard = ({ title, description, children }) => (
  <Card className="info-card" bordered={false}>
    <div className="info-card-title">{title}</div>
    <div className="info-card-description">{description}</div>
    {children}
  </Card>
)

export default InfoCard
